import React from "react";
import { YhPageHeader } from "@src/components/YhPageHeader";
import { SearchTypeEnum } from "@src/components/YhPageHeader/Types";
import { useMarketingTypeModel } from "../allMemberMarketingTypeModel";
import { StatusDs } from "@src/types/FmsDs";



export function PageHeader() {
    const {
        searchParam,
        marketingTypeDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useMarketingTypeModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "员工姓名",
            fieldName: "employeeName",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "营销类型",
            fieldName: "typeCode",
            size: "small",
            disabled: false,
            options: marketingTypeDs || []
        },
    ]
    return (
        <YhPageHeader
            title="营销类型"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}